<template>
  <v-container>
    <v-row>
      <v-col cols="12">
              <v-card color="primary" min-height="160">
                <v-card-title class="font-weight-bold">Unresolved Alerts</v-card-title>
                  <v-data-table dense :items-per-page="10" :headers="headers" :items="alertsUnresolved" :custom-sort="customSort">
                    <template v-slot:item.timestamp ="{ item }">
                      {{ formatDate(item.timestamp) }}
                    </template>
                    <template v-slot:item.severity ="{ item }">
                      <v-chip :color="getSeverityColor(item.severity)">{{ item.severity }}</v-chip>
                    </template>
                    <template v-slot:item.actions = "{ item }">
                      <v-btn icon @click="editRecord(item)"><v-icon>{{ getIconResolved(item.resolved)}}</v-icon></v-btn>
                    </template>                    
                  </v-data-table>
              </v-card>
      </v-col>      
    </v-row>

    <v-row justify="center">
      <v-dialog v-model="dialog1" max-width="500">
      <v-card>
        <v-card-title class="headline">New Alert Record</v-card-title>
          <v-card-text>
            <v-text-field v-model="editedItem.engineer" label="Engineer Name"></v-text-field>
          </v-card-text>
          <v-card-text>
            <v-text-field v-model="editedItem.comment" label="Report"></v-text-field>
          </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" text @click="saveRecord">Save</v-btn>
          <v-btn color="warning" text @click="dialog1 = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
      </v-dialog>
    </v-row>

  </v-container>
</template>


<script>
import * as d3 from "d3-time-format";

export default {
  props: {
      alertsData: Array,
      alertsSchema: Object
  },
  data: () => ({
    dialog1: false,
    editedIndex: -1,
    editedItem: {
      engineer: "",
      comment: "",
      timeRectified: null
    }
  }),
  computed: {
    headers: function() {
    return [
      { text: 'Timestamp', value: 'timestamp'},
      { text: 'Severity', value: 'severity'},
      { text: 'Alert Type', value: 'alertType'},
      { text: 'Actions', value: 'actions', sortable: false }
    ]},
    alertsUnresolved: function() {
      return this.alertsData.filter(ele => ele.resolved == "unresolved");
    }
  },
  methods: {
    editRecord(item){
      this.editedIndex = this.alertsData.indexOf(item);
      this.editedItem = Object.assign({}, item.report)        
      this.dialog1 = true;
    },
    saveRecord(){
      if (this.editedIndex > -1) {
        Object.assign(this.alertsData[this.editedIndex].report, this.editedItem)
        this.alertsData[this.editedIndex].resolved = "resolved";
      }
      this.dialog1 = false;
    },
    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        if (index[0] == "timestamp") {
          if (!isDesc[0]) {
            return a.timestamp - b.timestamp;
          } else {
            return b.timestamp - a.timestamp;
          }
        } else {
          if (!isDesc[0]) {
            return a[index[0]] < b[index[0]] ? -1 : 1;
          } else {
            return b[index[0]] < a[index[0]] ? -1 : 1;
          }
        }
      });
      return items;
    },
    formatDate(date){
      let format = d3.timeFormat("%B %d, %Y %H:%M:%S");
      return format(date);
    },
    getSeverityColor(severity){
      if (severity == "low") {
        return "green";
      } else if (severity == "moderate") {
        return "yellow";
      } else {
        return "red";
      }
    },
    getIconResolved(resolved){
      if (resolved == "resolved") {
        return "fa-eye";
      } else {
        return "fa-pencil-alt";
      }
    }
  }
}
</script>